<template lang="pug">
#graficoChuvaAcumuladaAno
    .grafico-chuva-acumulada-ano
        h2 {{ $t('mensagens.inteligenciaTerritorial.imovel.chuvaAcumuladaAno') }}
        apex-charts.component.apexcharts-canvas(
            type='line',
            height='370',
            :options='chartOptions',
            :series='dadosClimaticos'
        )
</template>

<script>
import formatters from '@/utils/formatters';
import ApexCharts from 'vue-apexcharts';

export default {
    name: 'GraficoChuvaAcumuladaAno',
    components: {
        ApexCharts
    },
    props: {
        dadosClimaticos: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {};
    },
    computed: {
        chartOptions: {
            get() {
                return {
                    plotOptions: {
                        bar: {
                            borderRadius: 3,
                            borderRadiusApplication: 'end',
                            columnWidth: '65%'
                        }
                    },
                    animations: {
                        enabled: true,
                        easing: 'easeinout',
                        speed: 800,
                        animateGradually: {
                            enabled: true,
                            delay: 150
                        },
                        dynamicAnimation: {
                            enabled: true,
                            speed: 350
                        }
                    },
                    noData: {
                        text: this.$t('mensagens.inteligenciaTerritorial.naoHaDadosASeremMostrados'),
                        align: 'center',
                        verticalAlign: 'middle',
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: undefined,
                            fontSize: '14px',
                            fontFamily: undefined
                        }
                    },
                    grid: {
                        show: true,
                        position: 'back',
                        xaxis: {
                            lines: {
                                show: false
                            }
                        },
                        yaxis: {
                            lines: {
                                show: true
                            }
                        },
                        row: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        column: {
                            colors: undefined,
                            opacity: 0.5
                        },
                        padding: {
                            top: 0,
                            right: 50,
                            bottom: 0,
                            left: 50
                        }
                    },
                    xaxis: {
                        categories: [
                            this.$t('constantes.mesesMaiusculo.janeiro'),
                            this.$t('constantes.mesesMaiusculo.fevereiro'),
                            this.$t('constantes.mesesMaiusculo.marco'),
                            this.$t('constantes.mesesMaiusculo.abril'),
                            this.$t('constantes.mesesMaiusculo.maio'),
                            this.$t('constantes.mesesMaiusculo.junho'),
                            this.$t('constantes.mesesMaiusculo.julho'),
                            this.$t('constantes.mesesMaiusculo.agosto'),
                            this.$t('constantes.mesesMaiusculo.setembro'),
                            this.$t('constantes.mesesMaiusculo.outubro'),
                            this.$t('constantes.mesesMaiusculo.novembro'),
                            this.$t('constantes.mesesMaiusculo.dezembro')
                        ],
                        labels: {
                            rotate: -45,
                            style: {
                                colors: ['#3B3B3B'],
                                fontSize: '12px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            }
                        },
                        tooltip: {
                            enabled: false
                        }
                    },
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: [
                        '#3D4766',
                        '#002279',
                        '#1140BA',
                        '#076CCA',
                        '#58AFFF',
                        '#E1A303'
                    ],
                    stroke: {
                        curve: 'smooth',
                        width: 3,
                        lineCap: 'round',
                        colors: [
                            'transparent',
                            'transparent',
                            'transparent',
                            'transparent',
                            'transparent',
                            '#E1A303'
                        ]
                    },
                    markers: {
                        size: 5,
                        strokeWidth: 0,
                        colors: '#E1A303',
                        hover: {
                            size: 8
                        }
                    },
                    title: {
                        text: ''
                    },
                    yaxis: {
                        showAlways: true,
                        forceNiceScale: true,
                        title: {
                            text: this.$t('mensagens.inteligenciaTerritorial.chuva'),
                            style: {
                                cssClass:
                                    'apexcharts-yaxis-title-text-chuva-acumulada'
                            }
                        },
                        min: 0,
                        labels: {
                            show: true,
                            formatter: value => {
                                return value.toFixed(0);
                            },
                            style: {
                                colors: ['#3B3B3B'],
                                fontSize: '12px',
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 500
                            }
                        },
                        decimalsInFloat: 0
                    },
                    tooltip: {
                        y: {
                            formatter: value => {
                                return formatters.formatNumber(value) + ' mm';
                            }
                        },
                        marker: {
                            show: true
                        },
                        theme: 'light'
                    },
                    fill: {
                        opacity: 1
                    },
                    legend: {
                        show: true,
                        position: 'top',
                        fontSize: '14px',
                        onItemClick: {
                            toggleDataSeries: true
                        },
                        markers: {
                            radius: 2,
                            width: 27,
                            height: 12
                        }
                    }
                };
            }
        }
    }
};
</script>

<style lang="scss">
#graficoChuvaAcumuladaAno {
    font-family: 'Roboto', 'sans serif';

    .grafico-chuva-acumulada-ano {
        height: 420px;
        border-radius: 8px;
        background: var(--white);
        padding: 10px 15px;
        color: var(--primary);

        .apexcharts-yaxis-title-text-chuva-acumulada {
            transform: translateX(55px) translateY(-165px) rotate(0deg);
            font-size: 14px;
            color: #3b3b3b;
            font-family: 'Roboto', sans-serif;
            font-weight: 700;
        }
        h2 {
            font-size: 16px;
            color: #3b3b3b;
            font-weight: 600;
            margin-bottom: 2px;
            margin-top: 10px;
        }
        .apexcharts-tooltip {
            background: var(--white);
        }
        .apexcharts-tooltip-title {
            background: var(--white);
            color: #3b3b3b;
            font-weight: 600;
        }
    }
}
</style>
